module.exports = __webpack_public_path__ + "img/12.0e8c17e5.jpg";